/*
|--------------------------------------------------------------------------
| Global helper functions, loaded synchronously as a first script in the theme head
|--------------------------------------------------------------------------
|
| It's available right away in all scripts used, without checking for availability
|
*/

//// mock fetch to test the error handling
//window.fetch = function(url, options) {
//    console.log(`fetch called with and url: ${url}`);
//    return Promise.resolve({
//        ok: false,
//        json: () => Promise.resolve({
//            description: 'Item is out of stock'
//        })
//    })
//}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/**
 * Csv string to array of lower case values
 * @param value
 * @returns {string[]}
 */
function parseCsvInputValue(value)
{
    return value.split(',').filter(value => value).map(value => value.toLowerCase())
}

/**
 * Check if string is a valid json
 * @param str
 * @returns {boolean}
 */
function isValidJson(str) {
    try {
        JSON.parse(str)
        return true
    } catch {
        return false
    }
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}